import { Injectable } from '@angular/core';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { TranslationService } from 'src/app/modules/i18n';

const I18N_VALUES: Record<string, { weekdays: string[]; months: string[] }> = {
  en: {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec',
    ],
  },
  tr: {
    weekdays: ['Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct', 'Pa'],
    months: [
      'Oca',
      'Şub',
      'Mar',
      'Nis',
      'May',
      'Haz',
      'Tem',
      'Ağu',
      'Eyl',
      'Eki',
      'Kas',
      'Ara',
    ],
  },
};

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private translation: TranslationService) {
    super();
  }

  private get current() {
    const lang = this.translation.getSelectedLanguage();
    return I18N_VALUES[lang] ? lang : 'en';
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this.current].weekdays[weekday - 1];
  }
  getWeekdayLabel(weekday: number): string {
    return this.getWeekdayShortName(weekday);
  }
  getWeekdayLabelPlural(): string {
    return '';
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this.current].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
  getDayAriaLabel(date: { year: number; month: number; day: number }): string {
    return `${date.day}.${date.month}.${date.year}`;
  }
}
